<div class="t-widget--noBottomPad">
  <header class="l-flex-column l-align-top">
    <h2 class="t-widgetTitle">
      {{ "translate.dashboard.supplyOrdersStatusSummaryTitle" | translate }}
    </h2>
    <hr />
  </header>

  <div class="content">
    <p *ngIf="data.openSuppliesOrdersCnt == 0">
      {{ "translate.dashboard.noOpenOrder" | translate }}
    </p>

    <p *ngIf="data.openSuppliesOrdersCnt > 0 && data.openSuppliesOrderDate">
      {{ getOpenOrderDateLbl(data.openSuppliesOrderDate) }}
    </p>
  </div>

  <div class="box-buttons">
    <button (click)="goToSuppliesOrder()" class="t-button-outline">
      {{ "translate.dashboard.goToSuppliesOrder" | translate }}
    </button>
  </div>
</div>
